module.exports = __webpack_public_path__ + "img/circle-1.cd058d93.png";